var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('home-hero'),_vm._v(" "),_c('home-whats-happening'),_vm._v(" "),_c('home-top-tour'),_vm._v(" "),_c('home-popular-attraction'),_vm._v(" "),_c('home-mak-and-greet'),_vm._v(" "),_c('home-social-media')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }